/**
 * @generated SignedSource<<8f99369d083cf56c977fc68caa7abbc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CateringOptionsSyncMutation$variables = {};
export type CateringOptionsSyncMutation$data = {
  readonly syncCateringOptions: {
    readonly recordsCreated: number;
    readonly recordsSkipped: number;
  };
};
export type CateringOptionsSyncMutation = {
  response: CateringOptionsSyncMutation$data;
  variables: CateringOptionsSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SyncCateringOptionsResult",
    "kind": "LinkedField",
    "name": "syncCateringOptions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recordsCreated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recordsSkipped",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CateringOptionsSyncMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CateringOptionsSyncMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0b7c192b22be375eb420df17ab79d3fa",
    "id": null,
    "metadata": {},
    "name": "CateringOptionsSyncMutation",
    "operationKind": "mutation",
    "text": "mutation CateringOptionsSyncMutation {\n  syncCateringOptions {\n    recordsCreated\n    recordsSkipped\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2d365835c8eed846930ce238027f00c";

export default node;
